/* eslint-disable */
import articleTemplate from '../article-listing-block/article-block';
import caseStudyTemplate from '../article-listing-block/case-study-block';

const ArticleListings = () => {
	const filterBlock = document.getElementById('c-article-listing--filters');
	const filterBlocks = document.querySelectorAll('.c-article-listing--filters__block');
	const allFilters = document.querySelectorAll('.c-article-listing--filters input');
	const filterToggles = document.querySelectorAll('.c-article-listing--filters-toggle');
	const filterClear = document.querySelectorAll('.c-article-listing--filters-clear');
	const industryList = document.querySelectorAll('.c-article-listing--filters-industries input');
	const industryStatus = document.querySelector('.c-article-listing--fitlers-status-industries');
	const capabilityList = document.querySelectorAll('.c-article-listing--filters-capabilities input');
	const capabilityStatus = document.querySelector('.c-article-listing--filters-status-capabilities');
	const noResultsMessage = document.getElementById('c-article-listing--no-results');
	const showMoreCta = document.getElementById('c-article-listing-show-more');
	const resultsArea = document.getElementById('c-article-listing__results');
	const baseString = '.c-article-listing--filters';
	let firstLoad = true;
	let enableFilterUrls = false;
	let contentType = "articles";
	let articleTypeName = "Articles";
	let baseUrl = "/en/insights/";
	let baseLanguage = "en";
	let tags = [];
	let tagsIndustries = [];
	let tagsCapabilities = [];
	let parentId = "";
	let preFilterTags = "";
	let endpoint = "/api/articles";
	let currentPage = 1;
	let pageSize = 20;

	const init = () => {
		if (allFilters.length > 0) {
			allFilters.forEach((element) => {
				element.addEventListener('change', function(e){  e.preventDefault(); handleSelect(element);});
			});
		}
		
		window.addEventListener('click', function(event) {
			var isClickInsideElement = filterBlock.contains(event.target);
			if (!isClickInsideElement){
				hideFilters();
			}
		});
			

		if (filterToggles.length > 0) {
			filterToggles.forEach((element) => {
				element.addEventListener('click', function(e){  e.preventDefault(); toggleFilters(element);});
			});
		}

		if (filterClear.length > 0) {
			filterClear.forEach((element) => {
				element.addEventListener('click', function(e){  e.preventDefault(); clearCheckboxes(element);});
			});
		}
		
		if (showMoreCta) {
			showMoreCta.addEventListener('click', () => {
				handleFetch(currentPage += 1);
			});
		}
		
		// Set up the variables
		enableFilterUrls = filterBlock.getAttribute('data-enable-filter-urls');
		baseUrl = filterBlock.getAttribute('data-base-url');
		baseLanguage = filterBlock.getAttribute('data-base-language');
		preFilterTags = filterBlock.getAttribute('data-prefilter');
		contentType = filterBlock.getAttribute('data-article-type');
		parentId = filterBlock.getAttribute('data-parent-id');
		endpoint = `/api/${contentType || 'articles'}/list/`;
		articleTypeName = contentType === 'casestudies' ? 'CaseStudies' : 'Articles';
		pageSize = 20;
		
		// Get the results for first load
		applyFilters();
	};

	const countCheckboxes = (filterType) => {
		const filterList = document.querySelectorAll(baseString + '-' + filterType + ' input');
		let counter = 0;
		let categories = '';
		if (filterList.length > 0) {
			filterList.forEach((item) => {
				if (item.checked) {
					if(counter > 0) {
						categories += ', ';
					}
					categories += item.getAttribute('name');
					counter++;
				}
			});
			
			const statusMessage = counter + ' selected';

			if(counter == 1) {
				setCounterMessage(filterType, counter, categories);
			}else{
				setCounterMessage(filterType, counter);
			}

			
			setStatusMessage(filterType, statusMessage);
			setMiniStatusMessage(filterType, categories);
		}
	};

	const setCounterMessage = (statusAreaName, count, item) => {
		const statusArea = document.querySelector(baseString + '-count-' + statusAreaName);
		const message = "(" + count + ")";
		if (statusArea) {
			if(count > 0) {
				if(count == 1){
					statusArea.innerHTML = item;
				}else{
					if(statusAreaName == "industries"){
						statusArea.innerHTML = "Industries " + message;
					}else{
						statusArea.innerHTML = "Topics " + message;
					}
				}
			} else {
				if(statusAreaName == "industries"){
					statusArea.innerHTML = "Filter by industry";
				}else{
					statusArea.innerHTML = "Filter by topic";
				}
			}
		}
	};

	const setStatusMessage = (statusAreaName, statusMessage) => {
		const statusArea = document.querySelector(baseString + '-status-' + statusAreaName);
		if (statusArea) {
			statusArea.innerHTML = statusMessage;
		}
	};

	const setMiniStatusMessage = (statusAreaName, statusMessage) => {
		const statusArea = document.querySelector(baseString + '-status-mini-' + statusAreaName);
		if (statusArea) {
			statusArea.innerHTML = statusMessage;
		}
	};

	// Clear checkboxes
	const clearCheckboxes = (item) => {
		const filterType = item.getAttribute('data-filter-clear');
		const filterList = document.querySelectorAll(baseString + '-' + filterType + ' input');

		if (filterList.length > 0) {
			filterList.forEach((item) => {
				item.checked = false;
				item.parentNode.classList.remove("active");
			});
		}

		setStatusMessage(filterType, '0 selected');
		setMiniStatusMessage(filterType, '');
		setCounterMessage(filterType, 0);
		applyFilters();
	};
	
	const toggleFilters = (item) => {
		const filterType = item.getAttribute('data-filter');
		if (item.classList.contains("active")) {
			hideFilters();
		} else {
			hideFilters();
			item.classList.add("active");
			
			const filterBlock = document.querySelector(baseString + '__block-' + filterType);
			if (filterBlock) {
				if(filterBlock.classList.contains("active")) {
					filterBlock.classList.remove("active");
				} else {
					filterBlock.classList.add("active");
				}
			}
		}
	};
	
	const hideFilters = () => {
		if (filterToggles.length > 0) {
			filterToggles.forEach((element) => {
				element.classList.remove("active");
			});
		}
		if (filterBlocks.length > 0) {
			filterBlocks.forEach((element) => {
				element.classList.remove("active");
			});
		}
	};

	const handleSelect = (item) => {
		item.parentNode.classList.toggle("active");
		// const filterType = item.getAttribute('data-filter-type');
		applyFilters();
	};
	
	const showNoResultsMessage = () => {
		noArticlesMessage.classList.add("active");
	};
	
	const hideNoResultsMessage = () => {
		noArticlesMessage.classList.remove("active");
	};
	
	const applyFilters = () => {
		tags = [];
		tagsIndustries = [];
		tagsCapabilities = [];
		if (allFilters.length > 0) {
			allFilters.forEach((item) => {
				const filterValue = item.getAttribute('value');
				const filterType = item.getAttribute('data-filter-type');
				if (item.checked) {				
					tags.push(filterValue);
					if(filterType == 'industries'){
						tagsIndustries.push(filterValue);
					}else{
						tagsCapabilities.push(filterValue);
					}
				}
			});
		}			

		if (firstLoad) {
			// If its fierst load use the pre-filter tags
			if (preFilterTags != ""){
				preFilterTags = preFilterTags.split("||");
				if(preFilterTags.length > 0){
					for (let i = 0; i < preFilterTags.length; i += 1) {
						tags.push(preFilterTags[i]);
						tagsCapabilities.push(preFilterTags[i]);
					}
				}
			}
			firstLoad = false;
		} else {
			if (baseUrl != '' && (enableFilterUrls === "true")){
				var urlTag = '';
				if (tags.length) {
					tags.forEach((tag) => {
						var cleanTag = tag.replace(/\s+/g, '-').toLowerCase();
						// Add a trailing slash if we have a tag
						if (cleanTag !== ''){
							urlTag = urlTag + cleanTag + "/";
						}
					});
				}

				// Add the selected filter to the URL
				history.pushState(null, null, baseUrl + urlTag);
			}
		}

		if (resultsArea) {
			resultsArea.innerHTML = '';
		}

		currentPage = 1;
		handleFetch();		
		
		countCheckboxes("industries");
		countCheckboxes("capabilities");
	};
	
	const handleFetch = () => {
		if (resultsArea) {

			fetch(endpoint, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					ParentItem: parentId,
					Tags: tags,
					Page: currentPage,
					PageSize: pageSize,
					CapabilityTags: tagsCapabilities,
					IndustryTags: tagsIndustries
				})
			})
				.then(r => {
					return r.json();
				})
				.then((response) => {
					parseData(response);
					return response;
				})
				.catch((error) => {
					console.log(error);
					if (resultsArea) {
						resultsArea.innerHTML = `
							<article class="col-12 c-article-listing__message">
								<h3>Error fetching results</h3>
							</article>
						`;
					}
				});
		}
	}
	
	const parseData = (data) => {
		// show the no results message and hide the more
		noResultsMessage.classList.add('hide');
		showMoreCta.classList.add('hide');	

		if (data['TotalResultsCount'] < 1) {
			if (noResultsMessage) {
				noResultsMessage.classList.remove('hide');
			}
		}else if (data[articleTypeName].length > pageSize) {
			if (showMoreCta) {
				showMoreCta.classList.remove('hide');	
			}
		}

		let result = '';
 		let industryTags = [];
		let capabilityTags = [];
		
		if (data[articleTypeName] && data[articleTypeName].length > 0) {
			const template = articleTypeName === 'CaseStudies' ? caseStudyTemplate : articleTemplate;

			for (let i = 0; i < data[articleTypeName].length; i += 1) {
				data[articleTypeName][i]["Language"] = baseLanguage;
				result += template(data[articleTypeName][i]);
				let item = data[articleTypeName][i];
			}
		}

		if (resultsArea) {
			resultsArea.innerHTML += result;

			// fade in new articles
			const mountedArticles = resultsArea.querySelectorAll('.c-article-listing__item--hidden');
			if (mountedArticles.length > 0) {
				const isInEditMode = document.body.classList.contains('editing-mode');
				mountedArticles.forEach((el, index) => {
					const elImage = el.querySelector('.c-content-block__image img');
					setTimeout(() => {
						el.classList.remove('c-article-listing__item--hidden');
						if (elImage) {
							elImage.classList.add('complete');						
						}
					}, isInEditMode ? 0 : (index + 1) * 250);					
				});
			}
		}

		if (showMoreCta) {
			// if current page of articles is less than results per page
			if (data[articleTypeName] && data[articleTypeName].length < data.ResultsPerPage) {
				showMoreCta.classList.add('hide');
				showMoreCta.setAttribute('aria-hidden', true);
			} else {
				showMoreCta.classList.remove('hide');
				showMoreCta.removeAttribute('aria-hidden');
			}
		}
	}
	
    if (filterBlock) {
        init();
    }
}

export default ArticleListings;
/* eslint-enable */
